export const positiveValidator = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const passwordValidator = value => {
  if (value.length >= 8) {
    return true
  }
  return false
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const maxDimensionsValidator = (
  files,
  [allowedwidth, allowedheight],
) => {
  const validateImage = (file, width, height) => {
    const URL = window.URL || window.webkitURL
    return new Promise(resolve => {
      const image = new Image()
      image.onerror = () => resolve({ valid: false })
      image.onload = () => resolve({
        valid: image.width <= Number(width) && image.height <= Number(height),
      })
      image.src = URL.createObjectURL(file)
    })
  }
  // console.log('here')
  // const list = []
  // for (let i = 0; i < files.length; i + 1) {
  //   // if file is not an image, reject.
  //   if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
  //     return false
  //   }
  //   list.push(files[i])
  // }
  // return Promise.all(
  //   list.map(file => validateImage(file, allowedwidth, allowedheight)),
  // )

  return validateImage(files, allowedwidth, allowedheight)
}
